var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZorraPart2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 29,
    viewBox: "0 0 117 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.314375 4.70191V1.45337H16.5571V4.43993L4.03448 24.2456H16.8191V27.4941H0V24.4028L12.4702 4.70191H0.314375Z",
    fill: "#949494"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7416 14.4999C45.7416 21.9658 39.6893 28.0181 32.2235 28.0181C24.7576 28.0181 18.7053 21.9658 18.7053 14.4999C18.7053 7.03409 24.7576 0.981812 32.2235 0.981812C39.6893 0.981812 45.7416 7.03409 45.7416 14.4999ZM22.2898 14.4999C22.2898 19.9862 26.7372 24.4336 32.2235 24.4336C37.7097 24.4336 42.1571 19.9862 42.1571 14.4999C42.1571 9.01373 37.7097 4.56627 32.2235 4.56627C26.7372 4.56627 22.2898 9.01373 22.2898 14.4999Z",
    fill: "#949494"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2477 1.50581V27.4942H53.601V17.5389H59.7837L65.5996 27.4942H69.4245L63.2942 17.1198C65.0757 16.4561 68.6386 13.976 68.6386 9.36519C68.6386 3.60165 63.2942 1.55821 61.6176 1.50581C60.2762 1.46389 53.4787 1.48835 50.2477 1.50581ZM53.601 14.3952V4.70196H61.1984C62.5432 4.78928 65.2329 5.84419 65.2329 9.36519C65.2329 12.8862 62.5432 14.1856 61.1984 14.3952H53.601Z",
    fill: "#949494"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3018 1.52888V27.5172H76.6552V17.562H82.8379L88.6538 27.5172H92.4787L86.3484 17.1429C88.1299 16.4792 91.6928 13.9991 91.6928 9.38826C91.6928 3.62472 86.3484 1.58128 84.6717 1.52888C83.3304 1.48696 76.5329 1.51142 73.3018 1.52888ZM76.6552 14.4183V4.72503H84.2526C85.5974 4.81235 88.287 5.86726 88.287 9.38826C88.287 12.9093 85.5974 14.2087 84.2526 14.4183H76.6552Z",
    fill: "#949494"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.429 1.50574L93.7362 27.4941H97.4147L99.4998 21.6258H111.236L113.332 27.4941H117L107.254 1.50574H103.429ZM100.705 18.4296L105.368 5.64501L110.031 18.4296H100.705Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZorraPart2);
export default __webpack_public_path__ + "static/media/zorra-part-2.9b57b8587e7fb70a2ca1a2797b72014a.svg";
export { ForwardRef as ReactComponent };